// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type ActivationChecklistStepKey = "site" | "template" | "inspection" | "capture" | "review" | "share";
export const ActivationChecklistStepKeySchema = z.enum(["site", "template", "inspection", "capture", "review", "share"] as const);

export type ActivationChecklistStep = {
  key: ActivationChecklistStepKey;
  title: string;
  description: string;
  completed: boolean;
  allowed: boolean;
  to: string | null;
  reason: string | null;
};
export const ActivationChecklistStepSchema = z.object({
  key: ActivationChecklistStepKeySchema,
  title: z.string(),
  description: z.string(),
  completed: z.boolean(),
  allowed: z.boolean(),
  to: z.string().nullable(),
  reason: z.string().nullable(),
}).strict();

export type ActivationChecklistResponse = {
  steps: Array<ActivationChecklistStep>;
  allCompleted: boolean;
  dismissed: boolean;
  dismissedAt: string | null;
};
export const ActivationChecklistResponseSchema = z.object({
  steps: z.array(ActivationChecklistStepSchema),
  allCompleted: z.boolean(),
  dismissed: z.boolean(),
  dismissedAt: z.string().nullable(),
}).strict();

export type GetActivationChecklistResponse = ActivationChecklistResponse;

export async function getActivationChecklist(): Promise<GetActivationChecklistResponse> {
  const response = await api.get<GetActivationChecklistResponse>(`/activation-checklist`);
  return response.data;
}

export type DismissActivationChecklistResponse = ActivationChecklistResponse;

export async function dismissActivationChecklist(): Promise<DismissActivationChecklistResponse> {
  const response = await api.post<DismissActivationChecklistResponse>(`/activation-checklist/dismiss`);
  return response.data;
}

export const activationChecklistKeys = {
  all: ["activationChecklist"] as const,
  lists: () => [...activationChecklistKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...activationChecklistKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...activationChecklistKeys.all, 'detail'] as const,
  detail: (id: string) => [...activationChecklistKeys.details(), id] as const,
};
